import { Button } from '@mgmresorts/mgm-ui';
import React, { useContext } from 'react';

import { useLoadingLabel } from '../../../../hooks/useLoadingLabel';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function CTASection() {
  const { processAccountSetup, isLoading, canProcessAccountSetup } = useContext(MlifeAccountSetupContext);
  const activateAccountSetupCTA = useLoadingLabel(isLoading, 'mlifeActivation.accountSetupSection.ctaSection.title');
  return (
    <Button
      variant='primary'
      size='large'
      label={activateAccountSetupCTA}
      testId='mlifeActivation-cta'
      disabled={isLoading || !canProcessAccountSetup}
      onClick={processAccountSetup}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          processAccountSetup();
        }
      }}
      className='identity__form-submit'
      loading={isLoading}
      fullWidth
      type='submit'
    />
  );
}

CTASection.displayName = 'CTASectionField';
